export const Square = () => {
  return (
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Frame 928904" filter="url(#filter0_bd_3869_25895)">
        <mask id="path-1-inside-1_3869_25895" fill="white">
          <path d="M2.66602 10.5332L31.6438 2.76863L39.4084 31.7464L10.4306 39.511L2.66602 10.5332Z" />
        </mask>
        <path
          d="M2.66602 10.5332L31.6438 2.76863L39.4084 31.7464L10.4306 39.511L2.66602 10.5332Z"
          fill="white"
          shapeRendering="crispEdges"
        />
        <path
          d="M2.66602 10.5332L2.27779 9.08431C1.47759 9.29873 1.00271 10.1212 1.21713 10.9214L2.66602 10.5332ZM31.6438 2.76863L33.0927 2.3804C32.8783 1.5802 32.0558 1.10533 31.2556 1.31974L31.6438 2.76863ZM39.4084 31.7464L39.7966 33.1953C40.5968 32.9809 41.0717 32.1584 40.8573 31.3582L39.4084 31.7464ZM10.4306 39.511L8.9817 39.8992C9.19611 40.6994 10.0186 41.1743 10.8188 40.9599L10.4306 39.511ZM3.05424 11.9821L32.032 4.21752L31.2556 1.31974L2.27779 9.08431L3.05424 11.9821ZM30.1949 3.15686L37.9595 32.1346L40.8573 31.3582L33.0927 2.3804L30.1949 3.15686ZM39.0201 30.2975L10.0424 38.0621L10.8188 40.9599L39.7966 33.1953L39.0201 30.2975ZM11.8795 39.1227L4.1149 10.145L1.21713 10.9214L8.9817 39.8992L11.8795 39.1227Z"
          fill="white"
          mask="url(#path-1-inside-1_3869_25895)"
        />
        <path
          id="Rectangle 4955"
          d="M30.4957 4.75773L37.4196 30.5981L11.5792 37.522L30.4957 4.75773Z"
          fill="url(#paint0_linear_3869_25895)"
        />
        <path
          id="Rectangle 4956"
          d="M11.579 37.5216L4.65512 11.6812L30.4955 4.75725L11.579 37.5216Z"
          fill="url(#paint1_linear_3869_25895)"
        />
      </g>
      <defs>
        <filter
          id="filter0_bd_3869_25895"
          x="-2.52629"
          y="-2.42278"
          width="47.1268"
          height="47.1268"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.59615" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3869_25895" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
          <feBlend mode="normal" in2="effect1_backgroundBlur_3869_25895" result="effect2_dropShadow_3869_25895" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3869_25895" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_3869_25895"
          x1="20.8337"
          y1="17.7955"
          x2="31.1798"
          y2="33.1513"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6D00" />
          <stop offset="1" stopColor="#F8EF6F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3869_25895"
          x1="6.55919"
          y1="18.7873"
          x2="21.9401"
          y2="19.5757"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#47FF65" />
          <stop offset="1" stopColor="#2C99FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
